import classNames from "classnames";
import { addHours, format } from "date-fns";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useState } from "react";
import { FaCalendarAlt, FaFileExcel, FaFilePdf, FaSearch, FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { mask, unMask } from "remask";
import AppCard from "../../../../components/appCard";
import { Api } from "../../../../services/api";
import { CalendarPague, LargeTablePague } from "../../../../styles/primeReactConfig";
import Base64ToPDF from "../../../../utils/Base64ToPDF";
import { formatCurrency } from "../../../../utils/formatCurrency";
import GeraXLSX from "../../../../utils/GeraXLSX";

export function RelatorioGerencial({ rowsPerPage }) {

  const [data, setData] = useState([]);

  const [diaInicial, setDiaInicial] = useState(new Date());
  const [diaFinal, setDiaFinal] = useState(new Date());

  const [loading, setLoading] = useState(false);
  const [first, setFirst] = useState(0);
  const [total, setTotal] = useState(0);

  const [, setPage] = useState(0);
  const [rows, setRows] = useState(() => {
    if (rowsPerPage) {
      return rowsPerPage[0];
    } else {
      return 10;
    }
  });
  const [rowsPerPageOptions] = useState(() => {
    if (rowsPerPage) {
      return rowsPerPage;
    } else {
      return [10, 20, 50];
    }
  });

  //const [dataset, setDataset] = useState([]);
  const [, setShowPdf] = useState(false);
  const [generating, setGenerating] = useState(false);

  const Search = async (page = 0, rows = 10, resetPagination = false) => {
    setLoading(true);

    const stringInicial = format(diaInicial, "yyyy-MM-dd");
    const stringFinal = format(diaFinal, "yyyy-MM-dd");

    if (resetPagination) {
      setPage(0);
      setRows(10);
      setFirst(0);
    }

    try {
      const { data } = await Api.get(`/relatorio/gerencial/${stringInicial}/${stringFinal}/${rows}/${page}`);
      setData(data.results);
      setTotal(data.count);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  function onPage(e) {
    const startIndex = parseInt(e.first);
    setRows(e.rows);
    setPage(e.page);
    setFirst(startIndex);

    return Search(e.page, e.rows);
  }

  async function handleSubmit() {
    try {
      Search();
    } catch (error) {
      console.log(error);
      toast.error("Houve um erro ao carregar as informações do relatório.");
    }
  }

  function handleClear() {
    setLoading(true);
    setPage(0);
    setRows(10);
    setFirst(0);
    setData([]);
    setDiaInicial();
    setDiaFinal();
    setLoading(false);
  }

  async function handleExport(exportType) {
    setGenerating(true);
    const stringInicial = format(diaInicial, "yyyy-MM-dd");
    const stringFinal = format(diaFinal, "yyyy-MM-dd");
    try {
      if (exportType === "xls") {
        const todos = await Api.get(`/relatorio/gerencial/${stringInicial}/${stringFinal}/${total}/0`);
        const dataset = formataDataset(todos.data.results);
        baixarXLSX(dataset)
        //setExportXLS(true);
        setGenerating(false);
        // setTimeout(() => setExportXLS(false), 500);
      } else {
        await relatorioPDFBack();
      }
    } catch (error) {
      console.log(error)
    }

  }

  function formataDataset(array) {
    const arrayFormatado = [];

    array.map((item) => {
      const taxaDireto = item.splits_valor_direto + item.splits_valor_protesto;
      arrayFormatado.push({
        cliente: item.usuario_nome ? item.usuario_nome.toUpperCase() : "-",
        documento: item.usuario_documento ? mask(unMask(item.usuario_documento), ["999.999.999-99", "99.999.999/9999-99"]) : "-",
        valor_pago: item.boleto_valor ? formatCurrency(item.boleto_valor) : "-",
        valor_provider: item.splits_valor_provider ? formatCurrency(item.splits_valor_provider) : "-",
        taxa_direto: taxaDireto ? formatCurrency(taxaDireto) : "-",
        vencimento: item.cobranca_data_vencimento ? format(addHours(new Date(item.cobranca_data_vencimento), 3), "dd/MM/yyyy") : "-",
        data_pagamento: item.boleto_data_pagamento ? format(addHours(new Date(item.boleto_data_pagamento), 3), "dd/MM/yyyy") : "-",
        data_repasse: item.data_transacao ? format(addHours(new Date(item.data_transacao), 3), "dd/MM/yyyy") : "-",
        situacao: item.situacao ? String(item.situacao).toUpperCase() : "-",
      });
    });

    // console.log(arrayFormatado);
    return (arrayFormatado);
  }

  const relatorioPDFBack = async () => {
    const stringInicial = format(diaInicial, "yyyy-MM-dd");
    const stringFinal = format(diaFinal, "yyyy-MM-dd");
    try {
      const { data } = await Api.get(`/relatorio/gerencial/pdf/${stringInicial}/${stringFinal}`);
      //console.log(data)
      Base64ToPDF(data, `Relatório_Receitas-${format(new Date(), 'dd-MM-yyyy')}`)
      setGenerating(false);
      setShowPdf(false)
    } catch (error) {
      console.log(error)
      setGenerating(false);
      setShowPdf(false)
      toast.error('Erro ao gerar pdf')
    }
  }

  function baixarXLSX(data) {
    let nome_arquivo = `Relatório_Receitas-${format(diaInicial, 'dd-MM-yyyy')}_a_${format(diaFinal, 'dd-MM-yyyy')}`
    const headers = [
      "Cliente",
      "Documento",
      "Valor pago",
      "Valor provider",
      "Taxa Direto",
      "Vencimento",
      "Data pagamento",
      "Data repasse",
      "Situação"
    ]
    const fields = [
      "cliente",
      "documento",
      "valor_pago",
      "valor_provider",
      "taxa_direto",
      "vencimento",
      "data_pagamento",
      "data_repasse",
      "situacao"
    ]

    const parametrosXLSX = {
      data: data,
      headers: headers,
      fields: fields,
      titulo: nome_arquivo
    }
    GeraXLSX(parametrosXLSX)
  }

  const Header = () => (
    <div className="flex flex-col w-full gap-2 p-3">
      <div className="text-xl w-full mb-2">
        <b>Relatório de Receitas</b>
      </div>
      <div className="flex flex-col md:flex-row gap-2">
        <div className="flex flex-col md:flex-row w-full lg:w-2/6 gap-2">
          <div className="w-full lg:w-[15rem]">
            <Calendar
              id="dia_inicial"
              locale="pt-BR"
              dateFormat="dd/mm/yy"
              required
              className="formularioAdimplencia"
              pt={CalendarPague}
              mask="99/99/9999"
              yearNavigator
              showIcon
              showOnFocus={false}
              icon={<FaCalendarAlt className={
                classNames('px-4 rounded-r-lg',
                  'w-[50px] h-full',
                  'bg-sky-400 text-white hover:bg-sky-500',
                  'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                )}
              />}
              value={diaInicial}
              onChange={(e) => setDiaInicial(e.value)}
              maxDate={new Date()}
              placeholder="Dia inicial"
            />
          </div>
          <div className="w-full lg:w-[15rem]">
            <Calendar
              id="dia_final"
              locale="pt-BR"
              dateFormat="dd/mm/yy"
              required
              className="formularioAdimplencia"
              pt={CalendarPague}
              mask="99/99/9999"
              yearNavigator
              showIcon
              showOnFocus={false}
              icon={<FaCalendarAlt className={
                classNames('px-4 rounded-r-lg',
                  'w-[50px] h-full',
                  'bg-sky-400 text-white hover:bg-sky-500',
                  'dark:bg-sky-500 dark:text-black dark:hover:bg-sky-400'
                )}
              />}
              value={diaFinal}
              onChange={(e) => setDiaFinal(e.value)}
              maxDate={new Date()}
              placeholder="Dia final"
            />
          </div>
        </div>
        <div className="flex flex-row justify-between md:w-4/6 gap-2">
          <div className="flex justify-center w-fit gap-2">
            <Button
              className="!px-[0.875rem]"
              severity="success"
              icon={<FaSearch className="text-xl" />}
              onClick={() => handleSubmit()}
            />
            <Button
              className="!px-[0.875rem]"
              severity="danger"
              icon={<FaTimes className="text-xl" />}
              onClick={() => handleClear()}
              type="button"
            />
          </div>
          <div className='flex w-fit gap-2'>
            <Button
              severity="success"
              label="Excel"
              icon={<FaFileExcel />}
              type="button"
              onClick={() => handleExport("xls")}
              loading={generating}
              disabled={data.length !== 0 ? false : true}
            />
            <Button
              severity="danger"
              label="PDF"
              icon={<FaFilePdf />}
              type="button"
              onClick={() => handleExport("pdf")}
              loading={generating}
              disabled={data.length !== 0 ? false : true}
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <AppCard className='!p-0'>
        <DataTable
          value={data}
          header={Header}
          loading={loading}
          rows={rows}
          rowsPerPageOptions={rowsPerPageOptions}
          totalRecords={total}
          first={first}
          pt={LargeTablePague}
          onPage={onPage}
          dataKey="boleto_id"
          currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          emptyMessage="Nenhuma informação encontrada. "
          scrollHeight="400px"
          scrollable
          paginator
          lazy
        >
          <Column className="text-left" header="Inadimplente" body={({ usuario_nome }) => usuario_nome} style={{ width: "12rem", fontSize: "90%" }} />
          <Column className="text-center" header="Documento" body={({ usuario_documento }) => mask(unMask(usuario_documento), ["999.999.999-99", "99.999.999/9999-99"])} style={{ width: "8rem", fontSize: "90%" }} />
          <Column className="text-center" header="Valor pago" body={({ boleto_valor }) => formatCurrency(boleto_valor)} style={{ width: "6rem", fontSize: "90%" }} />
          <Column className="text-center" header="Valor Credor" body={({ splits_valor_provider }) => formatCurrency(splits_valor_provider)} style={{ width: "6rem", fontSize: "90%" }} />
          <Column className="text-center" header="Taxa Direto" body={({ splits_valor_direto, splits_valor_protesto }) => formatCurrency(splits_valor_direto + splits_valor_protesto)} style={{ width: "6rem", justifyContent: 'center', fontSize: "90%" }} />
          <Column className="text-center" header="Vencimento" body={({ cobranca_data_vencimento }) => format(addHours(new Date(cobranca_data_vencimento), 3), "dd/MM/yyyy")} style={{ width: "7rem", fontSize: "90%" }} />
          <Column className="text-center" header="Data pagamento" body={({ boleto_data_pagamento }) => format(addHours(new Date(boleto_data_pagamento), 3), "dd/MM/yyyy")} style={{ width: "7rem", fontSize: "90%" }} />
          <Column className="text-center" header="Data repasse" body={({ data_transacao }) => (data_transacao ? format(addHours(new Date(data_transacao), 3), "dd/MM/yyyy") : "-")} style={{ width: "7rem", fontSize: "90%" }} />
          <Column className="text-center" header="Situação repasse" body={({ situacao }) => String(situacao).toUpperCase()} style={{ width: "7rem", fontSize: "90%" }} />
        </DataTable>
      </AppCard>
    </>
  );
}
